import * as Yup from 'yup';
import makeValidationSchema from '../../../hooks/makeValidationSchema';
import { CRM_EMAIL_FREQUENCY_VALUES } from './crmEmailFrequencies';

export const useScheme = makeValidationSchema(() =>
  Yup.object().shape({
    pursuitNotices: Yup.bool(),
    savedSearchNotices: Yup.bool(),
    teamUpdates: Yup.bool(),
    onEmailNotifications: Yup.bool(),
    taskReminders: Yup.bool(),
    pursuitDailyRecap: Yup.bool(),
    savedSearchDailyRecap: Yup.bool(),
    teamUpdatesDailyRecap: Yup.bool(),
    taskRemindersDailyRecap: Yup.bool(),
    personalTaskRemindersDailyRecap: Yup.bool(),
    crmUpdates: Yup.bool(),
    crmEmailFrequency: Yup.string().oneOf(['', ...CRM_EMAIL_FREQUENCY_VALUES]),
    crmDailyRecap: Yup.bool(),
  })
);
